import { BV_REVIEWS_LOADING, BV_REVIEWS_LOADED } from '../actionTypes/BVReviewsActionTypes';

export const BVReviewsLoading = () => ({ // eslint-disable-line
    type: BV_REVIEWS_LOADING,
});

export const BVReviewsLoaded = () => ({
    type: BV_REVIEWS_LOADED,
});
